import { createApp } from '@backstage/frontend-defaults';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import {
  createFrontendModule,
  discoveryApiRef,
  oauthRequestApiRef,
  ApiBlueprint,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { convertLegacyPlugin } from '@backstage/core-compat-api';
import { infisicalPlugin } from '@infisical/backstage-plugin-infisical';
import React from 'react';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';

const microsoftAuthApi = ApiBlueprint.make({
  name: 'microsoft',
  params: defineParams =>
    defineParams({
      api: microsoftAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi }) =>
        OAuth2.create({
          discoveryApi,
          oauthRequestApi,
          provider: {
            id: 'microsoft',
            title: 'Microsoft',
            icon: () => null,
          },
          defaultScopes: ['openid', 'profile', 'email', 'offline_access'],
        }),
    }),
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          provider={{
            id: 'microsoft-auth-provider',
            title: 'Microsoft',
            message: 'Entrar com sua conta Microsoft Everon',
            apiRef: microsoftAuthApiRef,
          }}
        />
      ),
  },
});

const toolsDashboard = PageBlueprint.make({
  name: 'tools',
  params: {
    path: '/',
    loader: async () => {
      const { HomePage } = await import('./components/HomePage');
      return <HomePage />;
    },
  },
});

const infisicalPage = PageBlueprint.make({
  name: 'infisical',
  params: {
    path: '/infisical',
    loader: async () => {
      const { InfisicalPage } = await import('./components/InfisicalPage');
      return <InfisicalPage />;
    },
  },
});


const trainingPage = PageBlueprint.make({
  name: 'treinamentos',
  params: {
    path: '/treinamentos',
    loader: async () => {
      const { TrainingCenterPage } = await import('./components/TrainingCenterPage');
      return <TrainingCenterPage />;
    },
  },
});

const costsPage = PageBlueprint.make({
  name: 'costs',
  params: {
    path: '/costs',
    loader: async () => {
      const { CostInsightsPage } = await import('./components/CostInsightsPage');
      return <CostInsightsPage />;
    },
  },
});

const plannerAgentPage = PageBlueprint.make({
  name: 'planner-agent',
  params: {
    path: '/planner-agent',
    loader: async () => {
      const { PlannerAgentPage } = await import('./components/PlannerAgentPage');
      return <PlannerAgentPage />;
    },
  },
});

const infisicalFrontendPlugin = convertLegacyPlugin(infisicalPlugin, {
  extensions: [],
});

export default createApp({
  features: [
    createFrontendModule({
      pluginId: 'app',
      extensions: [microsoftAuthApi, signInPage, toolsDashboard, infisicalPage, trainingPage, costsPage, plannerAgentPage],
    }),
    navModule,
    infisicalFrontendPlugin,
    catalogPlugin,
  ],
});
